import { EmptyState, Spinner } from "../../components/ui/misc";
import { useSpaces } from "../../lib/queries";
import { SpaceBody } from "./SpacePage";

/** The single Templates space (spec §4.3), an Admin section: the admin layout supplies the page bar. */
export function TemplatesPage() {
  const { data: spaces, isLoading } = useSpaces();
  const space = spaces?.find((s) => s.kind === "templates");
  if (isLoading) return <Spinner label="Loading…" />;
  if (!space)
    return (
      <EmptyState title="There are no templates yet" body="Templates appear here once the server has set them up." />
    );
  return <SpaceBody space={space} />;
}
